<template>
  <div class="space-y-4 text-sm md:text-base">
    <div>
      <h6 class="text-primary-300 mb-1">Does this even work? &#x1F937;</h6>
      <p>
      Maybe? Who knows. I mean it&rsquo;s not like I slapped together random
      numbers and called it a day. But hey, if you want to keep binge-watching
      until 3 AM and expect miracles, go ahead.
      </p>
    </div>
    <div>
      <h6 class="text-primary-300 mb-1">How can I trust this? &#x1F914;</h6>
      <p>
      Trust issues with a calculator? Maybe focus on that before tackling your
      circadian rhythm, champ.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SleepInfo',
};
</script>
